import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'rt-results-limit-button',
  templateUrl: './results-limit-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultsLimitButtonComponent {
  @Input() public limit: number;
  @Input() public limitOptions: number[] = [15, 30, 60, 90, 200];
  @Output() public limitChange: EventEmitter<number> = new EventEmitter();

  public trackByOptionValue(index: number, option: number): number {
    return option;
  }
}
